import { Directive, HostBinding, Input } from '@angular/core';

@Directive({
  selector: '[rmaLoadingIndicator]',
  standalone: true,
})
export class LoadingIndicatorDirective {
  @HostBinding('class.rma-loading-indicator') // this class is defined in the global stylesheet
  @Input()
  public rmaLoadingIndicator: boolean | null = false;
}
